/* eslint-disable @typescript-eslint/ban-ts-comment */
'use client'

import * as React from 'react'
import { useState, useContext, useEffect } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import ReactLoading from 'react-loading'
// @ts-ignore
import { authContext } from '../../../context/auth/context'
import { dispatchCustomEvent } from '../../../utils/dispatch'
// @ts-ignore
import { lang } from '../../../utils/langs'
// @ts-ignore
import phoneTools from '../../../assets/images/phone-tools.png'
// @ts-ignore
import phoneHome from '../../../assets/images/phone-home.png'
// @ts-ignore
import phoneVenta from '../../../assets/images/phone-venta.gif'
import './style.css'

interface InputProps {
  label?: string;
  placeholder?: string;
  icon?: React.ReactNode;
  type?: string;
  [key: string]: any;
}

const AppInput = (props: InputProps) => {
  const { label, placeholder, icon, type = 'text', ...rest } = props;
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleMouseMove = (e: React.MouseEvent) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className="app-input-wrapper">
      { label && 
        <label className='app-input-label'>
          {label}
        </label>
      }
      <div className="app-input-field-container">
        <input
          type={inputType}
          className="app-input-field"
          placeholder={placeholder}
          onMouseMove={handleMouseMove}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          {...rest}
        />
        {isHovering && (
          <>
            <div
              className="app-input-border-glow top"
              style={{
                background: `radial-gradient(30px circle at ${mousePosition.x}px 0px, var(--color-text-primary) 0%, transparent 70%)`,
              }}
            />
            <div
              className="app-input-border-glow bottom"
              style={{
                background: `radial-gradient(30px circle at ${mousePosition.x}px 2px, var(--color-text-primary) 0%, transparent 70%)`,
              }}
            />
          </>
        )}
        {isPassword ? (
          <button
            type="button"
            className="app-input-icon-btn"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        ) : icon && (
          <div className="app-input-icon">
            {icon}
          </div>
        )}
      </div>
    </div>
  )
}

const Page = () => {
  // @ts-ignore
  const { logIn } = useContext(authContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [mousePosition, setMousePosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  const [currentSlide, setCurrentSlide] = useState(0);
  // @ts-ignore
  const slides = [phoneHome, phoneTools, phoneVenta];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleMouseMove = (e: React.MouseEvent) => {
    const leftSection = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - leftSection.left,
      y: e.clientY - leftSection.top
    });
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) return;

    setIsLoading(true);
    logIn(email, password)
      .then((res: any) => {
        console.log(res);
      })
      .catch((error: any) => {
        dispatchCustomEvent("popup", { message: lang('es', error.message), type: "error" })
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="login-container-new">
      <div className="login-card-new">
        <div
          className="login-left-section"
          onMouseMove={handleMouseMove}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div
            className="login-glow-bg"
            style={{
              opacity: isHovering ? 1 : 0,
              transform: `translate(${mousePosition.x - 250}px, ${mousePosition.y - 250}px)`,
              transition: 'transform 0.1s ease-out, opacity 0.2s ease'
            }}
          />
          <div className="login-form-container">
            <form className="login-form-new" onSubmit={handleLogin}>
              <div className="form-header">
                <h1 className="login-title-new" onClick={(e) => {e.preventDefault()}}>Iniciar Sesión</h1>
              </div>
              <div className="inputs-container">
                <AppInput 
                  placeholder="Correo electrónico" 
                  type="email" 
                  value={email}
                  onChange={(e: any) => setEmail(e.target.value)}
                  required
                />
                <AppInput 
                  placeholder="Contraseña" 
                  type="password" 
                  value={password}
                  onChange={(e: any) => setPassword(e.target.value)}
                  required
                />
              </div>
              <a href="#" className="forgot-password-link-new">¿Olvidó su contraseña?</a>
              <div className="button-container">
                <button className="signin-btn" disabled={isLoading} type="submit">
                  {isLoading ? (
                    <ReactLoading type="spin" color="white" height={22} width={22} className="login-spinner" />
                  ) : (
                    <span>Iniciar Sesión</span>
                  )}
                  <div className="signin-btn-shine">
                    <div className="signin-btn-shine-bar" />
                  </div>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="login-right-section">
          <div className="login-right-brand-container">
            <h2 className="login-right-soon">EasyPOS Móvil</h2>
            <p className="login-right-desc">Tu negocio siempre contigo</p>
            <div className="phone-mockup">
              <div className="phone-screen">
                {slides.map((slide, idx) => (
                  <img
                    key={idx}
                    src={slide}
                    alt={`Preview ${idx}`}
                    className={`phone-slide-img ${idx === currentSlide ? 'active' : ''}`}
                  />
                ))}
              </div>
            </div>
            <span className="soon-badge">PRÓXIMAMENTE</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page
